<template>
  <div>
    <breadcrumbs
      :crumbs="[{name:`${participantSingularName} Dashboard`, link:'Dashboard Participant', id: $route.params.id},{name:'Referral'}]"
    />
    <div class="row">
      <div class="col-md-8">
        <div class="row">
          <div class="col-md-6 db-column" id="first-column">
            <profile-participant></profile-participant>
          </div>
          <div class="col-md-6 db-column" id="second-column">
            <assingment></assingment>
          </div>
        </div>
        <div class="row">
          <div class="col-md-12">
            <div class="portlet light">
              <div class="portlet-title">
                <div class="caption caption-md">
                  <span class="caption-subject bold uppercase">Referral Form</span>
                </div>
              </div>
              <div class="portlet-body">
                <spinner v-if="referralLoading"/>
                <template v-else>
                  <vue-form-render
                      v-if="this.referralForm.id"
                      :schema="referralForm.schema"
                      :conditions="referralForm.conditions"
                      :hideValues="referralForm.hideValues"
                      :calculations="referralForm.calculations"
                      :validation-conditions="referralForm.extra_validation_rules"
                      :values="referralForm.values"
                      :date-format="user.date_format"
                      :user-access-level="1"
                      :name="'referral-form'"
                      :referral-destination-accounts="referralDestinationAccounts"
                      :lockform="true">
                  </vue-form-render>
                  <div class="clearfix">
                    <a @click="printPage('/print/form/'+participant.referral_form_data_id)" class="btn default" :class="{'pull-right' : user.access >= 4}">Print</a>
                  </div>
                </template>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="col-md-4 db-column" id="third-column">
        <case-notes></case-notes>
      </div>
    </div>
    <!--END CONTENT BODY-->
  </div>
</template>
<script>
  import ProfileParticipant from '@/components/widgets/ProfileParticipant';
  import Assingment from '@/components/widgets/Assingment';
  import CaseNotes from '@/components/widgets/CaseNotes';
  import Breadcrumbs from '@/components/Breadcrumbs'
  import VueFormRender from "../components/formbuilder/VueFormRender";
  import Spinner from '@/components/Spinner';
  import {HTTP} from '../http-common.js';
  import {mapActions, mapGetters} from 'vuex';
  import participantDisplayName from '@/mixins/participantDisplayName';

  export default {
    mixins: [
      participantDisplayName
    ],
    data() {
      return {
        referralLoading: false,
        referralForm: {
          id: null
        }
      }
    },

    beforeMount() {
      if (this.$route.params.id) {
        this.loadParticipant(this.$route.params.id);
      }
    },

    computed: {
      ...mapGetters({
        'participant': 'getParticipant',
        'user': 'getUser',
        'organization': 'getOrganization'
      }),
      referralDestinationAccounts() {
        // we should not ask server for another organizations, that's why this value is hardcoded here
        return [this.organization.name]
      }
    },

    methods: {
      ...mapActions([
        'loadParticipant',
      ]),
      getReferralForm(dataId) {
        this.referralLoading = true;
        HTTP.post(`/form/data`, {data_id: dataId})
          .then(response => {
            if (response.data.status === 'success') {
              this.referralForm.id = response.data.data.form.id;
              this.referralForm.name = response.data.data.form.name;
              this.referralForm.schema = JSON.parse(response.data.data.form.data);
              this.referralForm.origin_schema = JSON.parse(response.data.data.form.data);
              this.referralForm.conditions = JSON.parse(response.data.data.form.conditionals);
              this.referralForm.calculations = JSON.parse(response.data.data.form.calculations);
              this.referralForm.extra_validation_rules = response.data.data.extra_validation_rules;
              this.referralForm.hide_values = JSON.parse(response.data.data.form.hide_values);
              this.referralForm.module_key = response.data.data.form.module_key;
              this.referralForm.values = response.data.data.values;
              this.referralForm.info = response.data.data.form_data;
            }
          }).catch(err => {
          console.log(err);
        }).finally(() => {
          this.referralLoading = false;
        });
      },
      printPage(url) {
        window.open(url, 'Print', 'left=0, top=0, width=1200, height=500, toolbar=0, resizable=0');
      },
    },

    components: {
      ProfileParticipant,
      Assingment,
      CaseNotes,
      Breadcrumbs,
      Spinner,
      VueFormRender
    },

    watch: {
      '$route.params.id': function () {
        this.loadParticipant(this.$route.params.id);
      },
      'participant': function (newVal) {
        if (newVal.hasOwnProperty('referral_form_data_id')) {
          this.getReferralForm(newVal.referral_form_data_id)
        }
      }
    }
  }
</script>



// WEBPACK FOOTER //
// ParticipantReferral.vue?683800a6